<template>
  <div id="slider">
    <figure>
      <img src="../assets/img/suppliers/Suppliers1.png" alt />
      <img src="../assets/img/suppliers/Suppliers2.png" alt />
      <img src="../assets/img/suppliers/Suppliers3.png" alt />
      <img src="../assets/img/suppliers/Suppliers4.png" alt />
      <img src="../assets/img/suppliers/Suppliers5.png" alt />
      <img src="../assets/img/suppliers/Suppliers6.png" alt />
      <img src="../assets/img/suppliers/Suppliers7.png" alt />
      <img src="../assets/img/suppliers/Suppliers1.png" alt />
      <img src="../assets/img/suppliers/Suppliers2.png" alt />
      <img src="../assets/img/suppliers/Suppliers3.png" alt />
      <img src="../assets/img/suppliers/Suppliers4.png" alt />
      <img src="../assets/img/suppliers/Suppliers5.png" alt />
      <img src="../assets/img/suppliers/Suppliers6.png" alt />
    </figure>
  </div>
</template>

<script>
export default {
  name: 'slider'
}
</script>
<style lang="scss" scoped>
$slider-height: var(--footer-height);
#slider {
  // width: 100%;
  overflow: hidden;
  height: $slider-height;
  // margin-left:-12px;
  // position: absolute;
  // bottom:0;
}
figure {
  position: relative;
  width: calc(#{$slider-height} * (25 / 2) * 13);
  height: $slider-height;
  margin: 0;
  padding: 0;
  animation: slidy 50s linear infinite;
}
img {
  width: calc(#{$slider-height} * (25 / 2));
}
@keyframes slidy {
  0% {
    left: 0%;
  }
  99.99999% {
    left: calc(#{$slider-height} * (25 / 2) * (-7));
  }
  100% {
    left: 0%;
  }
}
</style>
